import React, { useState, useEffect, useRef } from "react";
import { CircularProgress } from "@mui/material";
import Button from "./Button";
import CurrencyConverter, { toCurrency } from "@heartinz/currency_subunit_converter";
import { useContextApi } from "../../../context/ContextApi";
import { XIcon } from "../../../constants/Icons";

const UpdateWallet = ({
  onClose,
  onUpdateWalletIn,
  isBtnLoading,
  walletBalance = 0,
}) => {
  const [newBalance, setNewBalance] = useState("");
  const [diffBalance, setDiffBalance] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const amountRef = useRef(null);
  const buttonRef = useRef(null);
  const {useEscapeKey}=useContextApi();
  // When newBalance changes, recalculate difference
  useEffect(() => {
    const newVal = CurrencyConverter.toSubunit(newBalance||0,'INR');
    const oldVal = walletBalance;
    if (!isNaN(newVal) && newVal > 0) {
      setDiffBalance((newVal - oldVal).toFixed(2));
    } else {
      setDiffBalance("");
    }
  }, [newBalance, walletBalance]);

  const handleClose = () => {
    setNewBalance("");
    setErrorMessage("");
    onClose();
  };
  useEscapeKey(handleClose);
  const handleOnUpdateWalletIn = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    onUpdateWalletIn(parseFloat(newBalance));
  };

  const validateForm = () => {
    if (!newBalance) {
      setErrorMessage("New Balance cannot be empty.");
      amountRef?.current?.focus();
      return false;
    }
    const parsedValue = parseFloat(newBalance);
    if (isNaN(parsedValue) || parsedValue <= 0) {
      amountRef?.current?.focus();
      setErrorMessage("Enter a valid amount greater than 0.");
      return false;
    }
    const decimalPart = newBalance.split(".")[1];
    if (decimalPart && decimalPart.length !== 2) {
      amountRef?.current?.focus();
      setErrorMessage("Must have exactly 2 decimal places.");
      return false;
    }
    setErrorMessage("");
    return true;
  };

  const handleInputChange = (value) => {
    setErrorMessage("")
    let inputValue = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
    const [integerPart, decimalPart] = inputValue.split(".");

    if (decimalPart && decimalPart.length > 2) {
      inputValue = `${integerPart}.${decimalPart.slice(0, 2)}`;
    }

    if (inputValue.match(/^0\d/)) {
      inputValue = inputValue.replace(/^0+/, "") || "0";
    }

    setNewBalance(inputValue);
  };

  const handlePaymodeKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleOnUpdateWalletIn(e);
    }
  };

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: 360 }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Update Your Wallet Balance</h6>
              <button
                type="button"
                onClick={handleClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form className="row g-3">
                <div className="col-12">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <label className="form-label">Wallet Balance</label>
                    <p className="mb-0">
                      {CurrencyConverter.toCurrency(walletBalance ||0,'INR')}
                    </p>
                  </div>
                </div>

                <div className="col-12">
                  <label className="form-label">
                    New Balance <small className="text-danger">*</small>
                  </label>
                  <input
                    ref={amountRef}
                    type="text"
                    autoComplete="off"
                    className="form-control"
                    value={newBalance}
                    onKeyDown={(e)=>handlePaymodeKeyDown(e)}
                    onChange={(e) => handleInputChange(e.target.value)}
                    autoFocus 
                  />
                  {errorMessage && (
                    <small className="text-danger">{errorMessage}</small>
                  )}
                </div>

                <div className="col-12">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <label className="form-label mb-0">Difference</label>
                    <p className="mb-0">{CurrencyConverter.toCurrency(diffBalance||0,'INR')}</p>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer d-flex justify-content-between">
              <button
                onClick={handleClose}
                type="button"
                className="btn btn-outline-secondary"
              >
                <XIcon/> Cancel
              </button>
              {isBtnLoading ? (
                <button className="btn btn-primary" disabled>
                  <CircularProgress size={22} className="text-white" />
                </button>
              ) : (
                <Button
                  ref={buttonRef}
                  text="Update"
                  icon="bx bx-check"
                  bgColor="btn-primary"
                  textColor="text-white"
                  onClick={handleOnUpdateWalletIn}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateWallet;
